import { useMutation, useQuery } from '@apollo/client';
import { EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner } from '@elastic/eui';
import * as S from './SaveSearchFiltersGroup.theme';

import { DELETE_GROUP } from 'apollo-client/mutations/deleteSearchFiltersGroup';
import { SAVED_SEARCH_FILTERS_GROUPS } from 'apollo-client/queries/getSavedSeachFiltersGroup';
import { ListingFilters, Query } from 'generated/graphql';
import { applyFiltersGroup } from 'applyFiltersGroup';
import { useContext } from 'react';
import { ModalContext } from 'providers/modal-provider';
import { PopupProps } from 'components/Popup';
import { useIntl } from 'react-intl';

export const SearchFiltersGroups = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const { formatMessage } = useIntl();
  const [onDeleteGroup] = useMutation(DELETE_GROUP);
  const { setModal } = useContext(ModalContext);
  const { data, loading: getSavedSeachFiltersGroupLoading } = useQuery<Query, Query['getSavedSearchFiltersGroups']>(
    SAVED_SEARCH_FILTERS_GROUPS,
    {
      fetchPolicy: 'cache-and-network',
    }
  );

  const deleteSearchFiltersGroup = (ID: string): void => {
    onDeleteGroup({ variables: { id: ID }, refetchQueries: [SAVED_SEARCH_FILTERS_GROUPS] });
  };

  const handleApplyFilters = (filters: ListingFilters): void => {
    applyFiltersGroup({
      filters: filters,
      onError: () => {
        setModal<PopupProps>({
          type: 'Popup',
          props: {
            message: formatMessage({ id: 'error' }),
            details: formatMessage({ id: 'generic.error' }),
            status: 'ERROR',
          },
        });
      },
    });
    onClose();
  };
  const loading = getSavedSeachFiltersGroupLoading;
  return loading ? (
    <EuiFlexGroup justifyContent="spaceAround">
      <EuiFlexItem grow={true}>
        <EuiLoadingSpinner
          size="xl"
          style={{
            margin: '25vh auto',
          }}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  ) : (
    <S.Card title="Ricerche Salvate" textAlign="left">
      <EuiFlexGroup direction="column">
        {!data?.getSavedSearchFiltersGroups?.length ? (
          <div>Non esistono ricerche salvate</div>
        ) : (
          data?.getSavedSearchFiltersGroups?.map((group) => (
            <S.Row key={group.ID}>
              <EuiFlexGroup direction="row" justifyContent="spaceBetween">
                <div onClick={(): void => handleApplyFilters(group.filters)}>{group?.name}</div>
                <div className="delete" onClick={(): void => deleteSearchFiltersGroup(group.ID)}>
                  {formatMessage({ id: 'delete' })}
                </div>
              </EuiFlexGroup>
            </S.Row>
          ))
        )}
      </EuiFlexGroup>
    </S.Card>
  );
};
